import { render } from "./ro.vue?vue&type=template&id=310ab4de"
import script from "./ro.vue?vue&type=script&lang=js"
export * from "./ro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__